/**
 * Rutas internas del panel, declaradas una sola vez.
 *
 * La regla de los deep links vale también puertas adentro: un link que promete
 * abrir un registro y cae en "Esa pantalla no existe" es el mismo defecto que
 * una URL rota a Close, solo que en la navegación propia. Pasó exactamente eso:
 * cuatro módulos armaban `/clientes/{id}` con un template literal a mano y el
 * router no declaraba esa ruta, así que los links de /entrevistas caían en la
 * 404.
 *
 * El constructor de la ficha vive en `@ops/contracts` y se reexporta acá: la
 * API también arma esa dirección (el `href` de las alertas del Overview es parte
 * del contrato), así que el generador tiene que ser uno solo para los dos lados.
 * Este archivo agrega lo que es exclusivo del front: el patrón que declara el
 * router, armado sobre la misma constante.
 */
export { RUTA_CLIENTES, rutaCliente } from '@ops/contracts'

import { RUTA_CLIENTES } from '@ops/contracts'

/** Patrón que declara el router para la ficha. El `:clientId` vive solo acá. */
export const PATRON_CLIENTE = `${RUTA_CLIENTES}/:clientId`
